/* eslint-disable perfectionist/sort-enums */
export enum ActionKeys {
  // USER
  REVOKE_AUTH = 'REVOKE_AUTH',
  USER_SET_UNAUTHENTICATED = 'USER_SET_UNAUTHENTICATED',
  USER_FETCH = 'USER_FETCH',
  USER_FETCH_SUCCESS = 'USER_FETCH_SUCCESS',
  USER_FETCH_ERROR = 'USER_FETCH_ERROR',
  USER_ENTITLEMENTS_FETCH = 'USER_ENTITLEMENTS_FETCH',
  USER_ENTITLEMENTS_FETCH_SUCCESS = 'USER_ENTITLEMENTS_FETCH_SUCCESS',
  USER_ENTITLEMENTS_FETCH_ERROR = 'USER_ENTITLEMENTS_FETCH_ERROR',
  USER_REFRESH = 'USER_REFRESH',
  USER_ADD = 'USER_ADD',
  USER_DELETE = 'USER_DELETE',
  USER_RESEND_INVITE = 'USER_RESEND_INVITE',
  USER_ALL_FETCH = 'USER_ALL_FETCH',
  UPDATE_DEFAULT_ADDRESS = 'UPDATE_DEFAULT_ADDRESS',
  UPDATE_DEFAULT_RETURN_ADDRESS = 'UPDATE_DEFAULT_RETURN_ADDRESS',
  USER_UPDATE_CREDIT_CARD = 'USER_UPDATE_CREDIT_CARD',
  USER_UPDATE_CREDIT_CARD_SUCCESS = 'USER_UPDATE_CREDIT_CARD_SUCCESS',
  USER_SET_VERIFICATION_STATUS = 'USER_SET_VERIFICATION_STATUS',
  USER_CLOSE_VERIFICATION_MODAL = 'USER_CLOSE_VERIFICATION_MODAL',
  USER_INITIATE_ID_VERIFICATION = 'USER_INITIATE_ID_VERIFICATION',
  FETCH_APPS = 'FETCH_APPS',
  DELETE_APP = 'DELETE_APP',
  REGISTER = 'REGISTER',
  REGISTER_SUCCESS = 'REGISTER_SUCCESS',
  REGISTER_ERROR = 'REGISTER_ERROR',
  RESET_AUTH_ERROR = 'RESET_AUTH_ERROR',
  FINISH_REGISTER = 'FINISH_REGISTER',
  USER_ASSETS_FETCH = 'USER_ASSETS_FETCH',
  USER_ASSETS_FETCH_SUCCESS = 'USER_ASSETS_FETCH_SUCCESS',
  USER_ASSETS_FETCH_ERROR = 'USER_ASSETS_FETCH_ERROR',
  USER_ASSET_UPLOAD_DRAFT = 'USER_ASSET_UPLOAD_DRAFT',
  USER_ASSET_UPLOAD_DRAFT_SUCCESS = 'USER_ASSET_UPLOAD_DRAFT_SUCCESS',
  USER_ASSET_UPLOAD_DRAFT_ERROR = 'USER_ASSET_UPLOAD_DRAFT_ERROR',
  USER_ASSET_CLEAR_DRAFT = 'USER_ASSET_CLEAR_DRAFT',
  USER_ASSET_CLEAR_DRAFT_SUCCESS = 'USER_ASSET_CLEAR_DRAFT_SUCCESS',
  USER_ASSET_CLEAR_DRAFT_ERROR = 'USER_ASSET_CLEAR_DRAFT_ERROR',
  USER_ASSET_REVERT_DRAFT = 'USER_ASSET_REVERT_DRAFT',
  USER_ASSET_REVERT_DRAFT_SUCCESS = 'USER_ASSET_REVERT_DRAFT_SUCCESS',
  USER_ASSET_REVERT_DRAFT_ERROR = 'USER_ASSET_REVERT_DRAFT_ERROR',
  USER_ASSET_PUBLISH = 'USER_ASSET_PUBLISH',
  USER_ASSET_PUBLISH_SUCCESS = 'USER_ASSET_PUBLISH_SUCCESS',
  USER_ASSET_PUBLISH_ERROR = 'USER_ASSET_PUBLISH_ERROR',
  USER_ASSET_UPLOAD_AND_PUBLISH_LOGO = 'USER_ASSET_UPLOAD_AND_PUBLISH_LOGO',
  USER_ASSET_UPLOAD_AND_PUBLISH_LOGO_SUCCESS = 'USER_ASSET_UPLOAD_AND_PUBLISH_LOGO_SUCCESS',
  USER_ASSET_UPLOAD_AND_PUBLISH_LOGO_ERROR = 'USER_ASSET_UPLOAD_AND_PUBLISH_LOGO_ERROR',
  USER_BRAND_UPDATE_COLORS = 'USER_BRAND_UPDATE_COLORS',
  USER_BRAND_UPDATE_COLORS_SUCCESS = 'USER_BRAND_UPDATE_COLORS_SUCCESS',
  USER_BRAND_UPDATE_COLORS_ERROR = 'USER_BRAND_UPDATE_COLORS_ERROR',
  USER_EMAIL_VERIFICATION_SUCCESS = 'USER_EMAIL_VERIFICATION_SUCCESS',
  CSV_IMPORT_FILE_UPLOAD = 'CSV_IMPORT_FILE_UPLOAD',
  CSV_IMPORT_FILE_UPLOAD_SUCCESS = 'CSV_IMPORT_FILE_UPLOAD_SUCCESS',
  CSV_IMPORT_FILE_UPLOAD_ERROR = 'CSV_IMPORT_FILE_UPLOAD_ERROR',
  CSV_IMPORT_CHANGE_FIELD_MAPPING = 'CSV_IMPORT_CHANGE_FIELD_MAPPING',
  CSV_IMPORT_FETCH_TEMPLATES = 'CSV_IMPORT_FETCH_TEMPLATES',
  CSV_IMPORT_FETCH_TEMPLATES_SUCCESS = 'CSV_IMPORT_FETCH_TEMPLATES_SUCCESS',
  CSV_IMPORT_FETCH_TEMPLATES_ERROR = 'CSV_IMPORT_FETCH_TEMPLATES_ERROR',
  CSV_IMPORT_CHANGE_TEMPLATE = 'CSV_IMPORT_CHANGE_TEMPLATE',
  CSV_IMPORT_DELETE_TEMPLATE = 'CSV_IMPORT_DELETE_TEMPLATE',
  CSV_IMPORT_SAVE_TEMPLATE_SUCCESS = 'CSV_IMPORT_SAVE_TEMPLATE_SUCCESS',
  CSV_IMPORT_SAVE_TEMPLATE_ERROR = 'CSV_IMPORT_SAVE_TEMPLATE_ERROR',
  CSV_IMPORT_DELETE_TEMPLATE_SUCCESS = 'CSV_IMPORT_DELETE_TEMPLATE_SUCCESS',
  CSV_IMPORT_DELETE_TEMPLATE_ERROR = 'CSV_IMPORT_DELETE_TEMPLATE_ERROR',
  CSV_IMPORT_DELETE_TEMPLATE_MODAL_OPEN = 'CSV_IMPORT_DELETE_TEMPLATE_MODAL_OPEN',
  CSV_IMPORT_ORDERS_SUCCESS = 'CSV_IMPORT_ORDERS_SUCCESS',
  CSV_IMPORT_ORDERS_ERROR = 'CSV_IMPORT_ORDERS_ERROR',
  CSV_IMPORT_OPEN_SAVE_CSV_TEMPLATE_MODAL = 'CSV_IMPORT_OPEN_SAVE_CSV_TEMPLATE_MODAL',
  CSV_IMPORT_CLOSE_SAVE_CSV_TEMPLATE_MODAL = 'CSV_IMPORT_CLOSE_SAVE_CSV_TEMPLATE_MODAL',
  CSV_IMPORT_OPEN_ERROR_MESSAGE = 'CSV_IMPORT_OPEN_ERROR_MESSAGE',
  CSV_CLEAN_STATE = 'CSV_CLEAN_STATE',
  UPDATE_ACTIVATION_DATA = 'UPDATE_ACTIVATION_DATA',
  SHOW_PROMO_APPLICATION_NOTICE = 'SHOW_PROMO_APPLICATION_NOTICE',
  DISMISS_PROMO_APPLICATION_NOTICE = 'DISMISS_PROMO_APPLICATION_NOTICE',
  USER_FIRST_LABEL_PURCHASED = 'USER_FIRST_LABEL_PURCHASED',
  MAYBE_SHOW_EMAIL_VERIFICATION_MODAL = 'MAYBE_SHOW_EMAIL_VERIFICATION_MODAL',
  SHOW_EMAIL_VERIFICATION_MODAL = 'SHOW_EMAIL_VERIFICATION_MODAL',
  CLOSE_EMAIL_VERIFICATION_MODAL = 'CLOSE_EMAIL_VERIFICATION_MODAL',
  CHECK_REQUIRES_EMAIL_VERIFICATION = 'CHECK_REQUIRES_EMAIL_VERIFICATION',

  // Order
  ORDER_UNDO_SPLIT = 'ORDER_UNDO_SPLIT',
  ORDER_CREATE_PARTIAL_FULFILLMENT_REQUESTS = 'ORDER_CREATE_PARTIAL_FULFILLMENT_REQUESTS',
  ORDER_CREATE_PARTIAL_FULFILLMENT_REQUESTS_ERROR = 'ORDER_CREATE_PARTIAL_FULFILLMENT_REQUESTS_ERROR',
  ORDER_CREATE_PARTIAL_FULFILLMENT_REQUESTS_SUCCESS = 'ORDER_CREATE_PARTIAL_FULFILLMENT_REQUESTS_SUCCESS',
  ORDER_FETCH = 'ORDER_FETCH',
  ORDER_FETCH_SUCCESS = 'ORDER_FETCH_SUCCESS',
  ORDER_FETCH_ERROR = 'ORDER_FETCH_ERROR',
  ORDER_CLEAN = 'ORDER_CLEAN',
  ORDER_BATCH_ENTRY_FETCH = 'ORDER_BATCH_ENTRY_FETCH',
  ORDER_BATCH_ENTRY_FETCH_ERROR = 'ORDER_BATCH_ENTRY_FETCH_ERROR',
  ORDER_BATCH_ENTRIES_FETCH = 'ORDER_BATCH_ENTRIES_FETCH',
  ORDER_BATCH_ENTRIES_FETCH_SUCCESS = 'ORDER_BATCH_ENTRIES_FETCH_SUCCESS',
  ORDER_BATCH_ENTRIES_FETCH_ERROR = 'ORDER_BATCH_ENTRIES_FETCH_ERROR',
  ORDER_BATCH_ENTRIES_MARK_PROCESSING_SHIPMENT = 'ORDER_BATCH_ENTRIES_MARK_PROCESSING_SHIPMENT',
  ORDERS_BATCH_ENTRIES_POLL_START = 'ORDERS_BATCH_ENTRIES_POLL_START',
  ORDERS_BATCH_ENTRIES_POLL_END = 'ORDERS_BATCH_ENTRIES_POLL_END',
  ORDERS_BATCH_ENTRY_CONFIRM_RECIPIENT = 'ORDERS_BATCH_ENTRY_CONFIRM_RECIPIENT',
  ORDERS_FETCH = 'ORDERS_FETCH',
  ORDERS_FETCH_SUCCESS = 'ORDERS_FETCH_SUCCESS',
  ORDERS_FETCH_ERROR = 'ORDERS_FETCH_ERROR',
  ORDERS_SYNC = 'ORDERS_SYNC',
  ORDERS_SYNC_SUCCESS = 'ORDERS_SYNC_SUCCESS',
  ORDERS_SYNC_ERROR = 'ORDERS_SYNC_ERROR',
  ORDERS_COUNT_FETCH = 'ORDERS_COUNT_FETCH',
  ORDERS_COUNT_SUCCESS = 'ORDERS_COUNT_SUCCESS',
  ORDERS_COUNT_ERROR = 'ORDERS_COUNT_ERROR',
  ORDERS_POLL_START = 'ORDERS_POLL_START',
  ORDERS_GET_PACKING_SLIP = 'ORDERS_GET_PACKING_SLIP',
  ORDERS_GET_PACKING_SLIP_ERROR = 'ORDERS_GET_PACKING_SLIP_ERROR',
  ORDERS_CLEAR_AUTO_SAVE_ERRORS = 'ORDERS_CLEAR_AUTO_SAVE_ERRORS',
  BATCH_CREATE_SUCCESS = 'BATCH_CREATE_SUCCESS',
  BATCH_CREATE_ERROR = 'BATCH_CREATE_ERROR',
  ORDER_SCREEN_OPEN = 'ORDER_SCREEN_OPEN',
  ORDER_SCREEN_CLOSE = 'ORDER_SCREEN_CLOSE',
  ORDER_HIDE = 'ORDER_HIDE',
  ORDER_HIDE_SUCCESS = 'ORDER_HIDE_SUCCESS',
  ORDER_HIDE_ERROR = 'ORDER_HIDE_ERROR',
  ORDERS_UPDATE_PARCEL = 'ORDERS_UPDATE_PARCEL', // TODO: This will be replaced with ORDERS_UPDATE_BATCH_ENTRIES
  ORDERS_UPDATE_PARCEL_SUCCESS = 'ORDERS_UPDATE_PARCEL_SUCCESS',
  ORDERS_UPDATE_PARCEL_ERROR = 'ORDERS_UPDATE_PARCEL_ERROR',
  ORDERS_UPDATE_BATCH_ENTRIES_EXTRAS = 'ORDERS_UPDATE_BATCH_ENTRIES_EXTRAS',
  ORDERS_UPDATE_BATCH_ENTRIES_EXTRAS_SUCCESS = 'ORDERS_UPDATE_BATCH_ENTRIES_EXTRAS_SUCCESS',
  ORDERS_PATCH_UPDATE_BATCH_ENTRIES_EXTRAS = 'ORDERS_PATCH_UPDATE_BATCH_ENTRIES_EXTRAS',
  ORDERS_PATCH_UPDATE_BATCH_ENTRIES_EXTRAS_PACKING_SLIP_NOTE = 'ORDERS_PATCH_UPDATE_BATCH_ENTRIES_EXTRAS_PACKING_SLIP_NOTE',
  ORDERS_PATCH_UPDATE_BATCH_ENTRIES_EXTRAS_SUCCESS = 'ORDERS_PATCH_UPDATE_BATCH_ENTRIES_EXTRAS_SUCCESS',
  ORDERS_PATCH_UPDATE_BATCH_ENTRIES_EXTRAS_ERROR = 'ORDERS_PATCH_UPDATE_BATCH_ENTRIES_EXTRAS_ERROR',
  ORDERS_PATCH_UPDATE_BATCH_ENTRIES_EXTRAS_RESET = 'ORDERS_PATCH_UPDATE_BATCH_ENTRIES_EXTRAS_RESET',
  ORDERS_UPDATE_BATCH_ENTRIES_ADDRESS = 'ORDERS_UPDATE_BATCH_ENTRIES_ADDRESS',
  ORDERS_UPDATE_BATCH_ENTRIES_ADDRESS_SUCCESS = 'ORDERS_UPDATE_BATCH_ENTRIES_ADDRESS_SUCCESS',
  ORDERS_UPDATE_BATCH_ENTRIES_ADDRESS_ERROR = 'ORDERS_UPDATE_BATCH_ENTRIES_ADDRESS_ERROR',
  ORDERS_UPDATE_BATCH_ENTRIES_SERVICE_LEVEL_TOKEN = 'ORDERS_UPDATE_BATCH_ENTRIES_SERVICE_LEVEL_TOKEN',
  ORDERS_UPDATE_BATCH_ENTRIES_SERVICE_LEVEL_TOKEN_SUCCESS = 'ORDERS_UPDATE_BATCH_ENTRIES_SERVICE_LEVEL_TOKEN_SUCCESS',
  ORDERS_UPDATE_BATCH_ENTRIES_SERVICE_LEVEL_TOKEN_ERROR = 'ORDERS_UPDATE_BATCH_ENTRIES_SERVICE_LEVEL_TOKEN_ERROR',
  ORDERS_UPDATE_BATCH_ENTRIES_SHIPMENT_DATE = 'ORDERS_UPDATE_BATCH_ENTRIES_SHIPMENT_DATE',
  ORDERS_UPDATE_BATCH_ENTRIES_SHIPMENT_DATE_INITIATED = 'ORDERS_UPDATE_BATCH_ENTRIES_SHIPMENT_DATE_INITIATED',
  ORDERS_UPDATE_BATCH_ENTRIES_SHIPMENT_DATE_SUCCESS = 'ORDERS_UPDATE_BATCH_ENTRIES_SHIPMENT_DATE_SUCCESS',
  ORDERS_UPDATE_BATCH_ENTRIES_SHIPMENT_DATE_ERROR = 'ORDERS_UPDATE_BATCH_ENTRIES_SHIPMENT_DATE_ERROR',
  ORDERS_LOAD_AND_SELECT = 'ORDERS_LOAD_AND_SELECT',

  ORDERS_UPDATE_TAGS = 'ORDERS_UPDATE_TAGS',
  ORDERS_UPDATE_TAGS_SUCCESS = 'ORDERS_UPDATE_TAGS_SUCCESS',
  ORDERS_UPDATE_TAGS_ERROR = 'ORDERS_UPDATE_TAGS_ERROR',
  ORDERS_UPDATE_TAGS_CLEAR = 'ORDERS_UPDATE_TAGS_CLEAR',
  ORDERS_FETCH_TAGS = 'ORDERS_FETCH_TAGS',
  ORDERS_FETCH_TAGS_SUCCESS = 'ORDERS_FETCH_TAGS_SUCCESS',
  ORDERS_FETCH_TAGS_ERROR = 'ORDERS_FETCH_TAGS_ERROR',

  ORDERS_PATCH_BATCH_ENTRIES = 'ORDERS_PATCH_BATCH_ENTRIES',
  ORDERS_PATCH_BATCH_ENTRIES_SUCCESS = 'ORDERS_PATCH_BATCH_ENTRIES_SUCCESS',
  ORDERS_PATCH_BATCH_ENTRIES_ERROR = 'ORDERS_PATCH_BATCH_ENTRIES_ERROR',
  ORDERS_CLEAR_BATCH_ENTRIES = 'ORDERS_CLEAR_BATCH_ENTRIES',
  ORDERS_SELECT_ORDER = 'ORDERS_SELECT_ORDER',
  ORDERS_CLEAR_SELECTED = 'ORDERS_CLEAR_SELECTED',
  ORDERS_SELECT_CHECKED_ORDER = 'ORDERS_SELECT_CHECKED_ORDER',
  ORDERS_CLEAR_CHECKED_ORDERS = 'ORDERS_CLEAR_CHECKED_ORDERS',
  ORDERS_INITIATE_BULK_EDIT = 'ORDERS_INITIATE_BULK_EDIT',
  ORDERS_SYNC_SELECTED_ORDERS = 'ORDERS_SYNC_SELECTED_ORDERS',
  ORDERS_UPDATE_ROW_MODEL_BEING_EDITED = 'ORDERS_UPDATE_ROW_MODEL_BEING_EDITED',
  ORDERS_CLEAR_ROW_MODEL_BEING_EDITED = 'ORDERS_CLEAR_ROW_MODEL_BEING_EDITED',
  ORDERS_REMAINING_LABEL_DOWNLOAD = 'ORDERS_REMAINING_LABEL_DOWNLOAD',
  ORDERS_NEW_ORDERS_FOUND = 'ORDERS_NEW_ORDERS_FOUND',
  ORDERS_SAVE_LAST_ORDER_ID = 'ORDERS_SAVE_LAST_ORDER_ID',
  ORDERS_CREATE_ANOTHER_LABEL = 'ORDERS_CREATE_ANOTHER_LABEL',
  ORDERS_BATCH_FETCH_SUCCESS = 'ORDERS_BATCH_FETCH_SUCCESS',
  ORDERS_BATCH_FETCH_ERROR = 'ORDERS_BATCH_FETCH_ERROR',
  ORDERS_BATCH_POLL_START = 'ORDERS_BATCH_POLL_START',
  ORDERS_BATCH_POLL_END = 'ORDERS_BATCH_POLL_END',
  ORDERS_BATCH_POLL_TIMEOUT = 'ORDERS_BATCH_POLL_TIMEOUT',
  ORDERS_BATCH_ENTRY_RETRY_SHIPMENT = 'ORDERS_BATCH_ENTRY_RETRY_SHIPMENT',
  ORDERS_BATCH_CREATE_TRANSACTIONS = 'ORDERS_BATCH_CREATE_TRANSACTIONS',
  ORDERS_BATCH_CREATE_TRANSACTIONS_SUCCESS = 'ORDERS_BATCH_CREATE_TRANSACTIONS_SUCCESS',
  ORDERS_BATCH_CREATE_TRANSACTIONS_ERROR = 'ORDERS_BATCH_CREATE_TRANSACTIONS_ERROR',
  ORDERS_BATCH_STEP_CHANGE = 'ORDERS_BATCH_STEP_CHANGE',
  ORDERS_BATCH_GENERATE_PACKING_SLIPS = 'ORDERS_BATCH_GENERATE_PACKING_SLIPS',
  ORDERS_BATCH_GENERATE_PACKING_SLIPS_SUCCESS = 'ORDERS_BATCH_GENERATE_PACKING_SLIPS_SUCCESS',
  ORDERS_BATCH_GENERATE_PACKING_SLIPS_ERROR = 'ORDERS_BATCH_GENERATE_PACKING_SLIPS_ERROR',
  ORDERS_BATCH_GENERATE_ALL_LABELS = 'ORDERS_BATCH_GENERATE_ALL_LABELS',
  ORDERS_BATCH_GENERATE_ALL_LABELS_SUCCESS = 'ORDERS_BATCH_GENERATE_ALL_LABELS_SUCCESS',
  ORDERS_BATCH_GENERATE_ALL_LABELS_ERROR = 'ORDERS_BATCH_GENERATE_ALL_LABELS_ERROR',
  ORDERS_BATCH_ORDERS_FETCH_TRIGGERED = 'ORDERS_BATCH_ORDERS_FETCH_TRIGGERED',
  ORDERS_BATCH_CREATE_AND_BUY = 'ORDERS_BATCH_CREATE_AND_BUY',
  BATCH_ENTRY_RULES_FETCH = 'BATCH_ENTRY_RULES_FETCH',
  BATCH_ENTRY_RULES_FETCH_SUCCESS = 'BATCH_ENTRY_RULES_FETCH_SUCCESS',
  BATCH_ENTRY_RULES_FETCH_ERROR = 'BATCH_ENTRY_RULES_FETCH_ERROR',
  BATCH_ENTRY_RULES_CLEAR = 'BATCH_ENTRY_RULES_CLEAR',
  SHIPMENT_FETCH = 'SHIPMENT_FETCH',
  SHIPMENT_FETCH_SUCCESS = 'SHIPMENT_FETCH_SUCCESS',
  SHIPMENT_FETCH_ERROR = 'SHIPMENT_FETCH_ERROR',
  RATE_SELECT = 'RATE_SELECT',
  MULTIPLE_RATE_SELECT = 'MULTIPLE_RATE_SELECT',
  RATE_APPEND_HIDDEN_RATES = 'RATE_APPEND_HIDDEN_RATES',
  RATE_SET_HIDDEN_RATES = 'RATE_SET_HIDDEN_RATES',
  RATE_CLEAR_SELECTION = 'RATE_CLEAR_SELECTION',
  RATE_CLEAR = 'RATE_CLEAR',
  ORDERS_BATCH_ENTRY_EDIT_CLEAR_NOTIFICATION_MESSAGE = 'ORDERS_BATCH_ENTRY_EDIT_CLEAR_NOTIFICATION_MESSAGE',
  ORDERS_SET_CHECKOUT_RATE_AFTER_POLL = 'ORDERS_SET_CHECKOUT_RATE_AFTER_POLL',
  ORDERS_REMOVE_CHECKOUT_RATE_AFTER_POLL_ENTRY = 'ORDERS_REMOVE_CHECKOUT_RATE_AFTER_POLL_ENTRY',
  SHIPMENT_RECALCULATE_HIDDEN_RATES = 'SHIPMENT_RECALCULATE_HIDDEN_RATES',
  ORDERS_BATCH_TRANSACTION_DATA = 'ORDERS_BATCH_TRANSACTION_DATA',

  ORDER_CREATE_RETURN_BATCH_ENTRY = 'ORDER_CREATE_RETURN_BATCH_ENTRY',
  ORDER_CREATE_RETURN_BATCH_ENTRY_SUCCESS = 'ORDER_CREATE_RETURN_BATCH_ENTRY_SUCCESS',
  ORDER_CREATE_RETURN_LABEL = 'ORDER_CREATE_RETURN_LABEL',
  ORDER_CREATE_RETURN_LABEL_SUCCESS = 'ORDER_CREATE_RETURN_LABEL_SUCCESS',
  ORDER_CREATE_RETURN_LABEL_ERROR = 'ORDER_CREATE_RETURN_LABEL_ERROR',

  // Transactions
  FETCH_TRANSACTION = 'FETCH_TRANSACTION',
  FETCH_TRANSACTION_SUCCESS = 'FETCH_TRANSACTION_SUCCESS',
  FETCH_TRANSACTION_ERROR = 'FETCH_TRANSACTION_ERROR',
  SEND_EMAIL_NOTIFICATION = 'SEND_EMAIL_NOTIFICATION',
  SEND_EMAIL_NOTIFICATION_SUCCESS = 'SEND_EMAIL_NOTIFICATION_SUCCESS',
  SEND_EMAIL_NOTIFICATION_ERROR = 'SEND_EMAIL_NOTIFICATION_ERROR',
  UPDATE_SUCCESSFUL_TRANSACTIONS_COUNT = 'UPDATE_SUCCESSFUL_TRANSACTIONS_COUNT',
  UPDATE_FIRST_SUCCESSFUL_TRANSACTION_OBJECT_ID = 'UPDATE_FIRST_SUCCESSFUL_TRANSACTION_OBJECT_ID',

  // Invoice adjustments on Invoice Display
  DISPLAY_INVOICE_ADJUSTMENTS_FETCH = 'DISPLAY_INVOICE_ADJUSTMENTS_FETCH',
  DISPLAY_INVOICE_ADJUSTMENTS_FETCH_SUCCESS = 'DISPLAY_INVOICE_ADJUSTMENTS_FETCH_SUCCESS',
  DISPLAY_INVOICE_ADJUSTMENTS_FETCH_ERROR = 'DISPLAY_INVOICE_ADJUSTMENTS_FETCH_ERROR',

  USER_DID_AUTHENTICATE = 'USER_DID_AUTHENTICATE',
  DIALOG_SHOW = 'DIALOG_SHOW',
  DIALOG_HIDE = 'DIALOG_HIDE',
  PROMO_CODE_APPLY_OR_REPLACE = 'PROMO_CODE_APPLY_OR_REPLACE',
  PROMO_CODE_APPLY_OR_REPLACE_SUCCESS = 'PROMO_CODE_APPLY_OR_REPLACE_SUCCESS',
  PROMO_CODE_APPLY_OR_REPLACE_SUCCESS_CLEAR = 'PROMO_CODE_APPLY_OR_REPLACE_SUCCESS_CLEAR',
  PROMO_CODE_APPLY_OR_REPLACE_ERROR = 'PROMO_CODE_APPLY_OR_REPLACE_ERROR',
  PICKUPS_FETCH_TRANSACTIONS = 'PICKUPS_FETCH_TRANSACTIONS',
  PICKUPS_FETCH_TRANSACTIONS_SUCCESS = 'PICKUPS_FETCH_TRANSACTIONS_SUCCESS',
  PICKUPS_FETCH_TRANSACTIONS_ERROR = 'PICKUPS_FETCH_TRANSACTIONS_ERROR',
  PICKUPS_FETCH_CARRIER_ACCOUNT_ID = 'PICKUPS_CARRIER_ACCOUNT_ID',
  PICKUPS_FETCH_CARRIER_ACCOUNT_ID_SUCCESS = 'PICKUPS_CARRIER_ACCOUNT_ID_SUCCESS',
  PICKUPS_FETCH_CARRIER_ACCOUNT_ID_ERROR = 'PICKUPS_CARRIER_ACCOUNT_ID_ERROR',
  PICKUPS_FETCH_CARRIER_BUILDING_LOCATION_TYPES = 'PICKUPS_FETCH_CARRIER_BUILDING_LOCATION_TYPES',
  PICKUPS_FETCH_CARRIER_BUILDING_LOCATION_TYPES_SUCCESS = 'PICKUPS_FETCH_CARRIER_BUILDING_LOCATION_TYPES_SUCCESS',
  PICKUPS_FETCH_CARRIER_BUILDING_LOCATION_TYPES_ERROR = 'PICKUPS_FETCH_CARRIER_BUILDING_LOCATION_TYPES_ERROR',
  PICKUPS_SEND_PICKUPS_REQUEST = 'PICKUPS_SEND_PICKUPS_REQUEST',
  PICKUPS_SEND_PICKUPS_REQUEST_SUCCESS = 'PICKUPS_SEND_PICKUPS_REQUEST_SUCCESS',
  PICKUPS_SEND_PICKUPS_REQUEST_ERROR = 'PICKUPS_SEND_PICKUPS_REQUEST_ERROR',
  PICKUPS_RESET = 'PICKUPS_RESET',
  INITIALIZE_ANONYMOUS_TAG_MANAGER = 'INITIALIZE_ANONYMOUS_TAG_MANAGER',
  COMPANY_UPDATE = 'COMPANY_UPDATE',
  COMPANY_UPDATE_SUCCESS = 'COMPANY_UPDATE_SUCCESS',
  COMPANY_UPDATE_ERROR = 'COMPANY_UPDATE_ERROR',
  COMPANY_FETCH = 'COMPANY_FETCH',
  COMPANY_FETCH_SUCCESS = 'COMPANY_FETCH_SUCCESS',
  COMPANY_FETCH_ERROR = 'COMPANY_FETCH_ERROR',
  CUSTOMS_ITEM_CREATE = 'CUSTOMS_ITEM_CREATE',
  CUSTOMS_ITEM_CREATE_SUCCESS = 'CUSTOMS_ITEM_CREATE_SUCCESS',
  CUSTOMS_ITEM_CREATE_ERROR = 'CUSTOMS_ITEM_CREATE_ERROR',
  CUSTOMS_ITEM_UPDATE = 'CUSTOMS_ITEM_UPDATE',
  CUSTOMS_ITEM_UPDATE_SUCCESS = 'CUSTOMS_ITEM_UPDATE_SUCCESS',
  CUSTOMS_ITEM_UPDATE_ERROR = 'CUSTOMS_ITEM_UPDATE_ERROR',
  CUSTOMS_ITEM_DELETE = 'CUSTOMS_ITEM_DELETE',
  CUSTOMS_ITEM_DELETE_SUCCESS = 'CUSTOMS_ITEM_DELETE_SUCCESS',
  CUSTOMS_ITEM_DELETE_ERROR = 'CUSTOMS_ITEM_DELETE_ERROR',
  CUSTOMS_DECLARATION_UPDATE = 'CUSTOMS_DECLARATION_UPDATE',
  CUSTOMS_DECLARATION_UPDATE_SUCCESS = 'CUSTOMS_DECLARATION_UPDATE_SUCCESS',
  CUSTOMS_DECLARATION_UPDATE_ERROR = 'CUSTOMS_DECLARATION_UPDATE_ERROR',
  ORDER_BEGIN_EDIT_ACTION = 'ORDER_BEGIN_EDIT_ACTION',
  ORDER_END_EDIT_ACTION = 'ORDER_END_EDIT_ACTION',

  // Manual order
  MANUALORDER_RESET = 'MANUALORDER_RESET',
  MANUALORDER_SAVE_ORDER = 'MANUALORDER_SAVE_ORDER',
  MANUALORDER_CLEAR_ERROR_MESSAGE = 'MANUALORDER_CLEAR_ERROR_MESSAGE',
  MANUALORDER_SAVE_ORDER_SUCCESS = 'MANUALORDER_SAVE_ORDER_SUCCESS',
  MANUALORDER_SAVE_ORDER_FAILURE = 'MANUALORDER_SAVE_ORDER_FAILURE',

  // Snackbar
  SNACKBAR_ADD_MESSAGE = 'SNACKBAR_ADD_MESSAGE',

  // Stores
  STORES_FETCH = 'STORES_FETCH',
  STORES_FETCH_ERROR = 'STORES_FETCH_ERROR',
  STORES_FETCH_SUCCESS = 'STORES_FETCH_SUCCESS',

  UPDATE_ORDER_SHIPPED_EMAIL_SETTINGS = 'UPDATE_ORDER_SHIPPED_EMAIL_SETTINGS',
  UPDATE_ORDER_SHIPPED_EMAIL_SETTINGS_ERROR = 'UPDATE_ORDER_SHIPPED_EMAIL_SETTINGS_ERROR',
  UPDATE_ORDER_SHIPPED_EMAIL_SETTINGS_SUCCESS = 'UPDATE_ORDER_SHIPPED_EMAIL_SETTINGS_SUCCESS',

  UPDATE_ORDER_ARRIVED_EMAIL_SETTINGS = 'UPDATE_ORDER_ARRIVED_EMAIL_SETTINGS',
  UPDATE_ORDER_ARRIVED_EMAIL_SETTINGS_ERROR = 'UPDATE_ORDER_ARRIVED_EMAIL_SETTINGS_ERROR',
  UPDATE_ORDER_ARRIVED_EMAIL_SETTINGS_SUCCESS = 'UPDATE_ORDER_ARRIVED_EMAIL_SETTINGS_SUCCESS',

  UPDATE_BRAND_AND_FOOTER_SETTINGS = 'UPDATE_BRAND_AND_FOOTER_SETTINGS',
  UPDATE_BRAND_AND_FOOTER_SETTINGS_ERROR = 'UPDATE_BRAND_AND_FOOTER_SETTINGS_ERROR',
  UPDATE_BRAND_AND_FOOTER_SETTINGS_SUCCESS = 'UPDATE_BRAND_AND_FOOTER_SETTINGS_SUCCESS',

  FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS',
  FETCH_NOTIFICATIONS_ERROR = 'FETCH_NOTIFICATIONS_ERROR',
  FETCH_NOTIFICATIONS_SUCCESS = 'FETCH_NOTIFICATIONS_SUCCESS',
  SEND_SAMPLE_EMAIL = 'SEND_SAMPLE_EMAIL',
  SEND_SAMPLE_EMAIL_SUCCESS = 'SEND_SAMPLE_EMAIL_SUCCESS',
  SEND_SAMPLE_EMAIL_ERROR = 'SEND_SAMPLE_EMAIL_ERROR',
  CLEAR_SAMPLE_EMAIL_ERRORS = 'CLEAR_SAMPLE_EMAIL_ERRORS',

  // Tracking settings
  FETCH_TRACKING_CONFIG = 'FETCH_TRACKING_CONFIG',
  FETCH_TRACKING_CONFIG_ERROR = 'FETCH_TRACKING_CONFIG_ERROR',
  FETCH_TRACKING_CONFIG_SUCCESS = 'FETCH_TRACKING_CONFIG_SUCCESS',
  UPDATE_TRACKING_CONFIG = 'UPDATE_TRACKING_CONFIG',
  UPDATE_TRACKING_CONFIG_SUCCESS = 'UPDATE_TRACKING_CONFIG_SUCCESS',

  // Ebay Canada
  CLEAR_EBAY_CANADA_CONNECT_START_COOKIE = 'CLEAR_EBAY_CANADA_CONNECT_START_COOKIE',

  // Filters
  FILTER_SAVE_FILTER_GROUP = 'FILTER_SAVE_FILTER_GROUP',
  FILTER_SAVE_FILTER_GROUP_SUCCESS = 'FILTER_SAVE_FILTER_GROUP_SUCCESS',
  FILTER_SAVE_FILTER_GROUP_ERROR = 'FILTER_SAVE_FILTER_GROUP_ERROR',
  FILTER_GET_FILTER_GROUPS = 'FILTER_GET_FILTER_GROUPS',
  FILTER_GET_FILTER_GROUPS_SUCCESS = 'FILTER_GET_FILTER_GROUPS_SUCCESS',
  FILTER_GET_FILTER_GROUPS_ERROR = 'FILTER_GET_FILTER_GROUPS_ERROR',
  FILTER_DELETE_FILTER_GROUP = 'FILTER_DELETE_FILTER_GROUP',
  FILTER_DELETE_FILTER_GROUP_SUCCESS = 'FILTER_DELETE_FILTER_GROUP_SUCCESS',
  FILTER_DELETE_FILTER_GROUP_ERROR = 'FILTER_DELETE_FILTER_GROUP_ERROR',
  FILTER_SHOW_NEW_TAB = 'FILTER_SHOW_NEW_TAB',
  FILTER_HIDE_NEW_TAB = 'FILTER_HIDE_NEW_TAB',
  FILTER_CHANGE_TAB = 'FILTER_CHANGE_TAB',
  FILTER_CHANGE_TAB_SUCCESS = 'FILTER_CHANGE_TAB_SUCCESS',
  FILTER_DETERMINE_TAB_NAME = 'FILTER_DETERMINE_TAB_NAME',
  FILTER_SAVE_TEMP_GROUP = 'FILTER_SAVE_TEMP_GROUP',

  // Query Params
  CHANGE_QUERY_PARAMS = 'CHANGE_QUERY_PARAMS',
  UPDATE_QUERY_PARAM = 'UPDATE_QUERY_PARAM',
  STORE_CURRENT_QUERY_PARAMS = 'STORE_CURRENT_QUERY_PARAMS',
  RESTORE_QUERY_PARAMS = 'RESTORE_QUERY_PARAMS',

  // Settings - Parcel Templates
  SETTINGS_CLOSE_SAVE_PACKAGE_TEMPLATE_MODAL = 'SETTINGS_CLOSE_SAVE_PACKAGE_TEMPLATE_MODAL',
  SETTINGS_OPEN_SAVE_PACKAGE_TEMPLATE_MODAL = 'SETTINGS_OPEN_SAVE_PACKAGE_TEMPLATE_MODAL',
  FETCH_PACKAGE_DEFAULT_UNITS = 'FETCH_PACKAGE_DEFAULT_UNITS',
  FETCH_PACKAGE_DEFAULT_UNITS_SUCCESS = 'FETCH_PACKAGE_DEFAULT_UNITS_SUCCESS',
  FETCH_PACKAGE_DEFAULT_UNITS_ERROR = 'FETCH_PACKAGE_DEFAULT_UNITS_ERROR',
  UPDATE_PACKAGE_DEFAULT_UNITS = 'UPDATE_PACKAGE_DEFAULT_UNITS',
  UPDATE_PACKAGE_DEFAULT_UNITS_SUCCESS = 'UPDATE_PACKAGE_DEFAULT_UNITS_SUCCESS',
  SAVE_LABEL_SETTINGS = 'SAVE_LABEL_SETTINGS',
  SAVE_LABEL_SETTINGS_SUCCESS = 'SAVE_LABEL_SETTINGS_SUCCESS',
  FETCH_LABEL_SETTINGS = 'FETCH_LABEL_SETTINGS',
  FETCH_LABEL_SETTINGS_SUCCESS = 'FETCH_LABEL_SETTINGS_SUCCESS',

  // Carrier Form Fields
  CARRIER_FORM_FIELDS_CLEAR_STATE = 'CARRIER_FORM_FIELDS_CLEAR_STATE',
  FETCH_CARRIER_FORM_FIELDS = 'FETCH_CARRIER_FORM_FIELDS',
  FETCH_CARRIER_FORM_FIELDS_SUCCESS = 'FETCH_CARRIER_FORM_FIELDS_SUCCESS',
  FETCH_CARRIER_FORM_FIELDS_ERROR = 'FETCH_CARRIER_FORM_FIELDS_ERROR',

  // Carrier Form Input
  CARRIER_FORM_INPUT_EVENT = 'CARRIER_FORM_INPUT_EVENT',

  // Settings - Carrier Accounts
  CARRIER_ACCOUNTS_CLEAR_STATE = 'CARRIER_ACCOUNTS_CLEAR_STATE',
  CARRIER_ACCOUNTS_CLEAR_SUBMIT = 'CARRIER_ACCOUNTS_CLEAR_SUBMIT',
  FETCH_CARRIER_ACCOUNTS = 'FETCH_CARRIER_ACCOUNTS',
  FETCH_CARRIER_ACCOUNTS_SUCCESS = 'FETCH_CARRIER_ACCOUNTS_SUCCESS',
  FETCH_CARRIER_ACCOUNTS_ERROR = 'FETCH_CARRIER_ACCOUNTS_ERROR',
  CONNECT_CARRIER_ACCOUNT = 'CONNECT_CARRIER_ACCOUNT',
  CONNECT_CARRIER_ACCOUNT_SUCCESS = 'CONNECT_CARRIER_ACCOUNT_SUCCESS',
  CONNECT_CARRIER_ACCOUNT_ERROR = 'CONNECT_CARRIER_ACCOUNT_ERROR',
  EDIT_CARRIER_ACCOUNT = 'EDIT_CARRIER_ACCOUNT',
  EDIT_CARRIER_ACCOUNT_SUCCESS = 'EDIT_CARRIER_ACCOUNT_SUCCESS',
  EDIT_CARRIER_ACCOUNT_ERROR = 'EDIT_CARRIER_ACCOUNT_ERROR',
  EDIT_CARRIER_ACCOUNT_SERVICE_LEVELS = 'EDIT_CARRIER_ACCOUNT_SERVICE_LEVELS',
  EDIT_CARRIER_ACCOUNT_SERVICE_LEVELS_SUCCESS = 'EDIT_CARRIER_ACCOUNT_SERVICE_LEVELS_SUCCESS',
  EDIT_CARRIER_ACCOUNT_SERVICE_LEVELS_ERROR = 'EDIT_CARRIER_ACCOUNT_SERVICE_LEVELS_ERROR',
  CREATE_CARRIER_ACCOUNT = 'CREATE_CARRIER_ACCOUNT',
  CREATE_CARRIER_ACCOUNT_SUCCESS = 'CREATE_CARRIER_ACCOUNT_SUCCESS',
  CREATE_CARRIER_ACCOUNT_ERROR = 'CREATE_CARRIER_ACCOUNT_ERROR',

  TOGGLE_CARRIER_MODAL = 'TOGGLE_CARRIER_MODAL',

  FETCH_CARRIER_ACCOUNT_REG_STATUSES = 'FETCH_CARRIER_ACCOUNT_REG_STATUSES',
  FETCH_CARRIER_ACCOUNT_REG_STATUSES_SUCCESS = 'FETCH_CARRIER_ACCOUNT_REG_STATUSES_SUCCESS',
  FETCH_CARRIER_ACCOUNT_REG_STATUSES_ERROR = 'FETCH_CARRIER_ACCOUNT_REG_STATUSES_ERROR',

  FETCH_SERVICE_LEVELS_BY_ACCOUNT = 'FETCH_SERVICE_LEVELS_BY_ACCOUNT',
  FETCH_SERVICE_LEVELS_BY_ACCOUNT_SUCCESS = 'FETCH_SERVICE_LEVELS_BY_ACCOUNT_SUCCESS',
  FETCH_SERVICE_LEVELS_BY_ACCOUNT_ERROR = 'FETCH_SERVICE_LEVELS_BY_ACCOUNT_ERROR',

  // Feature tests
  FETCH_AB_TEST_FEATURES = 'FETCH_AB_TEST_FEATURES',
  FETCH_AB_TEST_FEATURES_SUCCESS = 'FETCH_AB_TEST_FEATURES_SUCCESS',
  INITIALIZE_FEATURE_TEST_VARIANT_NAMES = 'INITIALIZE_FEATURE_TEST_VARIANT_NAMES',

  UPDATE_USER_DEFAULT_SERVICE_LEVEL = 'UPDATE_USER_DEFAULT_SERVICE_LEVEL',
  UPDATE_USER_DEFAULT_RETURN_SERVICE_LEVEL = 'UPDATE_USER_DEFAULT_RETURN_SERVICE_LEVEL',

  // Address
  ADDRESSES_FETCH = 'ADDRESSES_FETCH',
  ADDRESSES_FETCH_ERROR = 'ADDRESSES_FETCH_ERROR',
  ADDRESSES_FETCH_SUCCESS = 'ADDRESSES_FETCH_SUCCESS',
  APIADDRESS_CREATE = 'APIADDRESS_CREATE',
  APIADDRESS_CREATE_SUCCESS = 'APIADDRESS_CREATE_SUCCESS',
  APIADDRESS_CREATE_ERROR = 'APIADDRESS_CREATE_ERROR',
  APIADDRESS_EDIT = 'APIADDRESS_EDIT',
  APIADDRESS_EDIT_SUCCESS = 'APIADDRESS_EDIT_SUCCESS',
  APIADDRESS_EDIT_ERROR = 'APIADDRESS_EDIT_ERROR',
  APIADDRESS_DELETE = 'APIADDRESS_DELETE',
  APIADDRESS_DELETE_SUCCESS = 'APIADDRESS_DELETE_SUCCESS',
  APIADDRESS_DELETE_ERROR = 'APIADDRESS_DELETE_ERROR',
  APIADDRESS_CLEAR_ERROR = 'APIADDRESS_CLEAR_ERROR',
  ADDRESS_BOOK_INITIALIZE = 'ADDRESS_BOOK_INITIALIZE',
  ADDRESS_BOOK_ACTION = 'ADDRESS_BOOK_ACTION',
  ADDRESS_BOOK_SELECT = 'ADDRESS_BOOK_SELECT',
  ADDRESS_BOOK_CLEAR_SELECTION = 'ADDRESS_BOOK_CLEAR_SELECTION',
  ADDRESS_BOOK_SELECT_DEFAULT = 'ADDRESS_BOOK_SELECT_DEFAULT',
  ADDRESS_BOOK_TOGGLE_COMBINE_SENDER_RETURN_ADDRESSES = 'ADDRESS_BOOK_TOGGLE_COMBINE_SENDER_RETURN_ADDRESSES',
  ADDRESS_BOOK_CLEAR_STATE = 'ADDRESS_BOOK_CLEAR_STATE',

  // Plans
  FETCH_USER_PLANS = 'FETCH_USER_PLANS',
  FETCH_USER_PLANS_SUCCESS = 'FETCH_USER_PLANS_SUCCESS',
  FETCH_USER_PLANS_ERROR = 'FETCH_USER_PLANS_ERROR',
  FETCH_PRICING_PLANS = 'FETCH_PRICING_PLANS',
  FETCH_PRICING_PLANS_SUCCESS = 'FETCH_PRICING_PLANS_SUCCESS',
  FETCH_PRICING_PLANS_ERROR = 'FETCH_PRICING_PLANS_ERROR',
  UPDATE_USER_PLAN = 'UPDATE_USER_PLAN',
  UPDATE_USER_PLAN_SUCCESS = 'UPDATE_USER_PLAN_SUCCESS',
  UPDATE_USER_PLAN_ERROR = 'UPDATE_USER_PLAN_ERROR',
  RESET_USER_PLAN_REQUEST = 'RESET_USER_PLAN_REQUEST',
  CLOSE_WIX_PRO_PLAN_NOTIFICATION = 'CLOSE_WIX_PRO_PLAN_NOTIFICATION',
  OPEN_CLOSE_ACCOUNT_MODAL = 'OPEN_CLOSE_ACCOUNT_MODAL',
  DISMISS_CLOSE_ACCOUNT_MODAL = 'DISMISS_CLOSE_ACCOUNT_MODAL',
  SUBMIT_CLOSE_ACCOUNT_FORM = 'SUBMIT_CLOSE_ACCOUNT_FORM',
  CLOSE_ACCOUNT_SUCCESS = 'CLOSE_ACCOUNT_SUCCESS',
  CLOSE_ACCOUNT_ERROR = 'CLOSE_ACCOUNT_ERROR',
  SET_ADJUSTED_PLAN = 'SET_ADJUSTED_PLAN',

  // Automations
  FETCH_BUSINESS_RULES = 'FETCH_BUSINESS_RULES',
  FETCH_BUSINESS_RULES_SUCCESS = 'FETCH_BUSINESS_RULES_SUCCESS',
  FETCH_BUSINESS_RULES_ERROR = 'FETCH_BUSINESS_RULES_ERROR',
  AUTOMATIONS_OPEN_DELETE_MODAL = 'AUTOMATIONS_OPEN_DELETE_MODAL',
  AUTOMATIONS_CLOSE_DELETE_MODAL = 'AUTOMATIONS_CLOSE_DELETE_MODAL',
  AUTOMATIONS_DELETE_RULE = 'AUTOMATIONS_DELETE_RULE',
  AUTOMATIONS_DELETE_RULE_SUCCESS = 'AUTOMATIONS_DELETE_RULE_SUCCESS',
  AUTOMATIONS_DELETE_RULE_ERROR = 'AUTOMATIONS_DELETE_RULE_ERROR',
  AUTOMATIONS_OPEN_ADD_RULE_MODAL = 'AUTOMATIONS_OPEN_ADD_RULE_MODAL',
  AUTOMATIONS_CLOSE_ADD_RULE_MODAL = 'AUTOMATIONS_CLOSE_ADD_RULE_MODAL',
  AUTOMATIONS_CREATE_RULE = 'AUTOMATIONS_CREATE_RULE',
  AUTOMATIONS_CREATE_RULE_SUCCESS = 'AUTOMATIONS_CREATE_RULE_SUCCESS',
  AUTOMATIONS_SET_RULE_ERROR = 'AUTOMATIONS_SET_RULE_ERROR',
  AUTOMATIONS_REORDER_RULES = 'AUTOMATIONS_REORDER_RULES',
  AUTOMATIONS_REORDER_RULES_SUCCESS = 'AUTOMATIONS_REORDER_RULES_SUCCESS',
  AUTOMATIONS_REORDER_RULES_ERROR = 'AUTOMATIONS_REORDER_RULES_ERROR',
  AUTOMATIONS_REPROCESS_RULES = 'AUTOMATIONS_REPROCESS_RULES',
  AUTOMATIONS_GET_REPROCESS_STATUS = 'AUTOMATIONS_GET_REPROCESS_STATUS',
  AUTOMATIONS_REPROCESS_RULES_POLL_START = 'AUTOMATIONS_REPROCESS_RULES_POLL_START',
  AUTOMATIONS_REPROCESS_RULES_POLL_END = 'AUTOMATIONS_REPROCESS_RULES_POLL_END',
  AUTOMATIONS_UPDATE_REPROCESS_STATUS = 'AUTOMATIONS_UPDATE_REPROCESS_STATUS',
  AUTOMATIONS_CLOSE_RULE_REPROCESS_PENDING_NOTIF = 'AUTOMATIONS_CLOSE_RULE_REPROCESS_PENDING_NOTIF',
  AUTOMATIONS_CLOSE_RULE_REPROCESS_COMPLETE_NOTIF = 'AUTOMATIONS_CLOSE_RULE_REPROCESS_COMPLETE_NOTIF',
  AUTOMATIONS_RESET_RULE_REPROCESS_PENDING_NOTIF = 'AUTOMATIONS_RESET_RULE_REPROCESS_PENDING_NOTIF',
  AUTOMATIONS_RESET_RULE_REPROCESS_COMPLETE_NOTIF = 'AUTOMATIONS_RESET_RULE_REPROCESS_COMPLETE_NOTIF',

  // Orders Page Modals
  ORDERS_START_CHECKOUT = 'ORDERS_START_CHECKOUT',
  ORDERS_RESTART_CHECKOUT = 'ORDERS_RESTART_CHECKOUT',
  ORDERS_RETRY_CHECKOUT = 'ORDERS_RETRY_CHECKOUT',
  ORDERS_CHECKOUT_TOGGLE = 'ORDERS_CHECKOUT_TOGGLE',
  ORDERS_CHECKOUT_CONFIRM = 'ORDERS_CHECKOUT_CONFIRM',
  ORDERS_CHECKOUT_CONFIRM_WITH_ERROR = 'ORDERS_CHECKOUT_CONFIRM_WITH_ERROR',
  ORDERS_CHECKOUT_SEND_EMAIL_NOTIFICATIONS = 'ORDERS_CHECKOUT_SEND_EMAIL_NOTIFICATIONS',
  ORDERS_CHECKOUT_SEND_EMAIL_NOTIFICATIONS_SUCCESS = 'ORDERS_CHECKOUT_SEND_EMAIL_NOTIFICATIONS_SUCCESS',
  ORDERS_CHECKOUT_SEND_EMAIL_NOTIFICATIONS_ERROR = 'ORDERS_CHECKOUT_SEND_EMAIL_NOTIFICATIONS_ERROR',
  ORDER_SPLIT_MODAL_OPEN = 'ORDER_SPLIT_MODAL_OPEN',
  ORDER_SPLIT_MODAL_CLOSE = 'ORDER_SPLIT_MODAL_CLOSE',

  // Line Items
  LINE_ITEMS_DELETE = 'LINE_ITEMS_DELETE',
  LINE_ITEMS_DELETE_SUCCESS = 'LINE_ITEMS_DELETE_SUCCESS',
  LINE_ITEMS_DELETE_ERROR = 'LINE_ITEMS_DELETE_ERROR',
  LINE_ITEM_CREATE = 'LINE_ITEMS_CREATE',
  LINE_ITEM_CREATE_SUCCESS = 'LINE_ITEM_CREATE_SUCCESS',
  LINE_ITEM_CREATE_ERROR = 'LINE_ITEM_CREATE_ERROR',
  LINE_ITEM_EDIT = 'LINE_ITEM_EDIT',
  LINE_ITEM_EDIT_SUCCESS = 'LINE_ITEM_EDIT_SUCCESS',
  LINE_ITEM_EDIT_ERROR = 'LINE_ITEM_EDIT_ERROR',

  // Help chat
  HELP_OPEN_CHAT = 'HELP_OPEN_CHAT',
  HELP_OPEN_CHAT_SUCCESS = 'HELP_OPEN_CHAT_SUCCESS',

  // Branding
  BRANDING_SET_UPLOAD_FILE_ERROR = 'BRANDING_SET_UPLOAD_FILE_ERROR',
  BRANDING_CLOSE_UPLOAD_LOGO_NOTIF = 'BRANDING_CLOSE_UPLOAD_LOGO_NOTIF',
  BRANDING_CLOSE_UPDATE_COLOR_NOTIF = 'BRANDING_CLOSE_UPDATE_COLOR_NOTIF',

  // Billing
  BILLING_OPEN_CREDIT_CARD_MODAL = 'BILLING_OPEN_CREDIT_CARD_MODAL',
  BILLING_CLOSE_CREDIT_CARD_MODAL = 'BILLING_CLOSE_CREDIT_CARD_MODAL',

  // Rates at Checkout
  RATES_AT_CHECKOUT_FETCH_SHIPPING_OPTIONS = 'RATES_AT_CHECKOUT_FETCH_SHIPPING_OPTIONS',
  RATES_AT_CHECKOUT_FETCH_SHIPPING_OPTIONS_SUCCESS = 'RATES_AT_CHECKOUT_FETCH_SHIPPING_OPTIONS_SUCCESS',
  RATES_AT_CHECKOUT_FETCH_SHIPPING_OPTIONS_ERROR = 'RATES_AT_CHECKOUT_FETCH_SHIPPING_OPTIONS_ERROR',
  RATES_AT_CHECKOUT_UPDATE_SHIPPING_OPTION = 'RATES_AT_CHECKOUT_UPDATE_SHIPPING_OPTION',
  RATES_AT_CHECKOUT_UPDATE_SHIPPING_OPTION_SUCCESS = 'RATES_AT_CHECKOUT_UPDATE_SHIPPING_OPTION_SUCCESS',
  RATES_AT_CHECKOUT_UPDATE_SHIPPING_OPTION_ERROR = 'RATES_AT_CHECKOUT_UPDATE_SHIPPING_OPTION_ERROR',
  RATES_AT_CHECKOUT_CREATE_SHIPPING_OPTION = 'RATES_AT_CHECKOUT_CREATE_SHIPPING_OPTION',
  RATES_AT_CHECKOUT_CREATE_SHIPPING_OPTION_SUCCESS = 'RATES_AT_CHECKOUT_CREATE_SHIPPING_OPTION_SUCCESS',
  RATES_AT_CHECKOUT_CREATE_SHIPPING_OPTION_ERROR = 'RATES_AT_CHECKOUT_CREATE_SHIPPING_OPTION_ERROR',
  RATES_AT_CHECKOUT_DELETE_SHIPPING_OPTION = 'RATES_AT_CHECKOUT_DELETE_SHIPPING_OPTION',
  RATES_AT_CHECKOUT_DELETE_SHIPPING_OPTION_SUCCESS = 'RATES_AT_CHECKOUT_DELETE_SHIPPING_OPTION_SUCCESS',
  RATES_AT_CHECKOUT_DELETE_SHIPPING_OPTION_ERROR = 'RATES_AT_CHECKOUT_DELETE_SHIPPING_OPTION_ERROR',
  RATES_AT_CHECKOUT_OPEN_ADD_RULE_MODAL = 'RATES_AT_CHECKOUT_OPEN_ADD_RULE_MODAL',
  RATES_AT_CHECKOUT_CLOSE_ADD_RULE_MODAL = 'RATES_AT_CHECKOUT_CLOSE_ADD_RULE_MODAL',
  RATES_AT_CHECKOUT_FETCH_LIVE_RATE_PACKAGE = 'RATES_AT_CHECKOUT_FETCH_LIVE_RATE_PACKAGE',
  RATES_AT_CHECKOUT_FETCH_LIVE_RATE_PACKAGE_SUCCESS = 'RATES_AT_CHECKOUT_FETCH_LIVE_RATE_PACKAGE_SUCCESS',
  RATES_AT_CHECKOUT_FETCH_LIVE_RATE_PACKAGE_ERROR = 'RATES_AT_CHECKOUT_FETCH_LIVE_RATE_PACKAGE_ERROR',
  RATES_AT_CHECKOUT_UPDATE_LIVE_RATE_PACKAGE = 'RATES_AT_CHECKOUT_UPDATE_LIVE_RATE_PACKAGE',
  RATES_AT_CHECKOUT_UPDATE_LIVE_RATE_PACKAGE_SUCCESS = 'RATES_AT_CHECKOUT_UPDATE_LIVE_RATE_PACKAGE_SUCCESS',
  RATES_AT_CHECKOUT_UPDATE_LIVE_RATE_PACKAGE_ERROR = 'RATES_AT_CHECKOUT_UPDATE_LIVE_RATE_PACKAGE_ERROR',
  RATES_AT_CHECKOUT_FETCH_LIVE_RATE_SENDER_ADDRESS = 'RATES_AT_CHECKOUT_FETCH_LIVE_RATE_SENDER_ADDRESS',
  RATES_AT_CHECKOUT_FETCH_LIVE_RATE_SENDER_ADDRESS_SUCCESS = 'RATES_AT_CHECKOUT_FETCH_LIVE_RATE_SENDER_ADDRESS_SUCCESS',
  RATES_AT_CHECKOUT_FETCH_LIVE_RATE_SENDER_ADDRESS_ERROR = 'RATES_AT_CHECKOUT_FETCH_LIVE_RATE_SENDER_ADDRESS_ERROR',
  RATES_AT_CHECKOUT_UPDATE_LIVE_RATE_SENDER_ADDRESS = 'RATES_AT_CHECKOUT_UPDATE_LIVE_RATE_SENDER_ADDRESS',
  RATES_AT_CHECKOUT_UPDATE_LIVE_RATE_SENDER_ADDRESS_SUCCESS = 'RATES_AT_CHECKOUT_UPDATE_LIVE_RATE_SENDER_ADDRESS_SUCCESS',
  RATES_AT_CHECKOUT_UPDATE_LIVE_RATE_SENDER_ADDRESS_ERROR = 'RATES_AT_CHECKOUT_UPDATE_LIVE_RATE_SENDER_ADDRESS_ERROR',

  MANIFESTS_FETCH = 'MANIFESTS_FETCH',
  MANIFESTS_FETCH_SUCCESS = 'MANIFESTS_FETCH_SUCCESS',
  MANIFESTS_FETCH_ERROR = 'MANIFESTS_FETCH_ERROR',
  MANIFESTS_DOWNLOAD_ZIP = 'MANIFESTS_DOWNLOAD_ZIP',
  MANIFESTS_DOWNLOAD_ZIP_SUCCESS = 'MANIFESTS_DOWNLOAD_ZIP_SUCCESS',
  MANIFESTS_DOWNLOAD_ZIP_ERROR = 'MANIFESTS_DOWNLOAD_ZIP_ERROR',
  MANIFESTS_FETCH_SUCCESS_TERMINAL_STATE = 'MANIFESTS_FETCH_SUCCESS_TERMINAL_STATE',
  MANIFESTS_GROUPS_FETCH = 'MANIFESTS_GROUPS_FETCH',
  MANIFESTS_GROUPS_FETCH_SUCCESS = 'MANIFESTS_GROUPS_FETCH_SUCCESS',
  MANIFESTS_GROUPS_FETCH_ERROR = 'MANIFESTS_GROUPS_FETCH_ERROR',
  MANIFESTS_UPDATE_ADDRESS = 'MANIFESTS_UPDATE_ADDRESS',
  MANIFESTS_GENERATE = 'MANIFESTS_GENERATE',
  MANIFESTS_GENERATE_ERROR = 'MANIFESTS_GENERATE_ERROR',
  MANIFESTS_GENERATE_SUCCESS = 'MANIFESTS_GENERATE_SUCCESS',
  MANIFESTS_POLL_START = 'MANIFESTS_POLL_START',
  MANIFESTS_POLL_END = 'MANIFESTS_POLL_END',

  GENERATE_TOKEN = 'GENERATE_TOKEN',
  FETCH_TOKEN = 'FETCH_TOKEN',
  DELETE_TOKEN = 'DELETE_TOKEN',
  SAVE_WEBHOOK = 'SAVE_WEBHOOK',
  FETCH_WEBHOOKS = 'FETCH_WEBHOOKS',
  TEST_WEBHOOK = 'TEST_WEBHOOK',
  EDIT_WEBHOOK = 'EDIT_WEBHOOK',
  DELETE_WEBHOOK = 'DELETE_WEBHOOK',
  FETCH_VERSION = 'FETCH_VERSION',
  UPGRADE_VERSION = 'UPGRADE_VERSION',

  // Login
  RESET_PASSWORD_SUBMIT = 'RESET_PASSWORD_SUBMIT',
  RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS',
  RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR',
}
